<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">用户修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                    <el-form>
                        <el-col :span="12" class="item">
                            <el-form-item label='手机号'>
                                <el-input placeholder="请输入手机号" v-model="edit_phone" maxlength="11" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" class="item">
                            <el-form-item label='所属政府'>
                                <el-select v-model="edit_governmentCode" clearable placeholder="请选择政府" style="width:100%">
                                    <el-option
                                            v-for="item in governmentValue"
                                            :key="item.governmentCode"
                                            :label="item.name"
                                            :value="item.governmentCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-row>
            </div>

            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>

        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: 'Edit',
        props: ['governmentValue'],
        data() {
            return {

                loading: false,
                pageSize:20,
                currentPage:1,
                edit_phone:'',
                edit_governmentCode:'',
                userCode:'',
            }
        },
        methods: {
            init(row){
                this.userCode = row.userCode;
                this.edit_phone = row.phone;
                this.edit_governmentCode = row.governmentCode;
            },

            closeSelf() {
                this.loading= false
                this.$emit("closeEdit");
            },
            confirm(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'User/Edit',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        userCode:this.userCode,
                        phone:this.edit_phone,
                        governmentCode:this.edit_governmentCode,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.$emit("closeEdit");
                        this.$emit("getList");
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },
        }
    }
</script>

<style  lang="scss" scoped>
    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

    .modal {
        background-color: #fff;
        box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width: 600px;
        height: 270px;

    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px 0px;
        z-index: 99;
        overflow-y:auto;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }


    }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }

</style>